import React, { useState, useEffect } from "react";
import Header from "../../../Componets/Header";
import Loadercomponent from "../../../Componets/Loader";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import headers from "../../../Data/Tables/Settings/Upgrade/headers";
import { get_all_feature_locks, get_user_plan, get_user_features } from "../../../Controllers/FeatureLock";
import toast from "react-hot-toast";
import {
  RocketOutlined,
  CrownOutlined,
  StarOutlined,
  ThunderboltOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  RiseOutlined,
  SafetyOutlined,
  TrophyOutlined,
  LockOutlined,
  UnlockOutlined,
  HighlightOutlined,
  RightOutlined,
  ShopOutlined,
  SwapOutlined,
  ApartmentOutlined
} from "@ant-design/icons";
import { get_all_sub_branches } from "../../../Controllers/Settings/Branches";
import { downgrade_plan_request_email, feature_unlock_request_email, upgrade_plan_request_email } from "../../../Controllers/FeatureUnLockMail";
import UserCurrency from "../../../Componets/UserCurrency";

const UpgradationDisplay = () => {
  const [header, setHeader] = useState(headers);
  const [loader, setLoader] = useState(false);
  const [features, setFeatures] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [userPlan, setUserPlan] = useState();
  const [userFeature, setUserFeature] = useState([]);
  const [userData, setUserData] = useState(null);
  const [subBranches, setSubBranches] = useState([]);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [showDowngradeModal, setShowDowngradeModal] = useState(false);
  const [showBranchSelector, setShowBranchSelector] = useState(false);
  const [hoveredFeature, setHoveredFeature] = useState(null);
  const [selectedBranchForAction, setSelectedBranchForAction] = useState(null);
  const [showFeatureUnlockModal, setShowFeatureUnlockModal] = useState(false);
  const [selectedFeatureForUnlock, setSelectedFeatureForUnlock] = useState(null);
  const [selectedBranchForFeatureUnlock, setSelectedBranchForFeatureUnlock] = useState(null);


  const PLANS = [
    {
      id: 1000,
      name: "Basic",
      icon: StarOutlined,
      color: "from-blue-500 to-blue-600",
      lightColor: "bg-blue-50",
      borderColor: "border-blue-200",
      textColor: "text-blue-700",
      badgeColor: "bg-blue-100 text-blue-800",
      features: [],
      Amount: 1000
    },
    {
      id: 2000,
      name: "Standard",
      icon: ThunderboltOutlined,
      color: "from-green-500 to-green-600",
      lightColor: "bg-green-50",
      borderColor: "border-green-200",
      textColor: "text-green-700",
      badgeColor: "bg-green-100 text-green-800",
      features: [],
      Amount: 1560
    },
    {
      id: 3000,
      name: "Premium",
      icon: CrownOutlined,
      color: "from-amber-500 to-amber-600",
      lightColor: "bg-amber-50",
      borderColor: "border-amber-200",
      textColor: "text-amber-700",
      badgeColor: "bg-amber-100 text-amber-800",
      features: [],
      Amount: 2560
    }
  ];

  const formdata = (data) => { };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);
      const data = {
        search: tabledata?.search,
        status: tabledata?.status,
      };

      const FeatureLock = await get_all_feature_locks(data);

      if (FeatureLock?.status) {
        let organizedFeatures = FeatureLock?.data?.map(feature => {
          const userFeatureData = userFeature?.find(
            uf => uf._id === feature._id
          );

          return {
            ...feature,
            planAccessMap: feature.plan_access.reduce((acc, plan) => {
              acc[plan.plan] = plan.allowed;
              return acc;
            }, {}),
            status_per_branch: userFeatureData?.status_per_branch || []
          };
        }) || [];

        organizedFeatures.sort((a, b) => {
          const aCount = Object.values(a.planAccessMap).filter(Boolean).length;
          const bCount = Object.values(b.planAccessMap).filter(Boolean).length;

          if (bCount !== aCount) return bCount - aCount;

          return a.standalone_amount - b.standalone_amount;
        });

        setFeatures(organizedFeatures);
        setLoader(false);
      } else {
        toast?.error(FeatureLock?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
      setLoader(false);
    }
  };

  const fetchUserPlan = async () => {
    try {
      setLoader(true);
      const User_Plan = await get_user_plan();

      if (User_Plan?.status) {
        setUserData(User_Plan?.data);
        setUserPlan(User_Plan?.data?.plan);
        setSelectedBranch({
          id: User_Plan?.data?._id,
          name: User_Plan?.data?.name,
          type: 'main',
          plan: User_Plan?.data?.plan
        });
      } else {
        toast?.error(User_Plan?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
      setLoader(false);
    }
  };

  const fetchSubbranches = async () => {
    try {
      setLoader(true);
      const sub_branches = await get_all_sub_branches();

      if (sub_branches?.status) {
        setSubBranches(sub_branches?.data?.data || []);
      } else {
        toast?.error(sub_branches?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
      setLoader(false);
    }
  };

  const fetchUserFeatures = async () => {
    try {
      setLoader(true);
      const User_Features = await get_user_features();

      if (User_Features?.status) {
        setUserFeature(User_Features?.data);
      } else {
        toast?.error(User_Features?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchUserPlan();
    fetchSubbranches();
    fetchUserFeatures();
  }, []);

  useEffect(() => {
    if (userFeature.length) {
      fetchData();
    }
  }, [userFeature]);

  const handleUpgradeRequest = (planId) => {
    setSelectedPlan(planId);
    setSelectedBranchForAction(selectedBranch);
    setShowBranchSelector(true);
  };

  const handleDowngradeRequest = (planId) => {
    setSelectedPlan(planId);
    setSelectedBranchForAction(selectedBranch);
    setShowBranchSelector(true);
  };

  const handleBranchSelect = (branch) => {
    setSelectedBranchForAction(branch);
  };

  const openFeatureUnlockModal = (feature) => {
    setSelectedFeatureForUnlock(feature);
    setSelectedBranchForFeatureUnlock(selectedBranch);
    setShowFeatureUnlockModal(true);
  };

  const confirmFeatureUnlock = async (localSelectedBranch) => {
    try {
      const response = await feature_unlock_request_email({
        feature_ids: [
          selectedFeatureForUnlock._id
        ],
        branch_id: localSelectedBranch.id
      });

      if (response?.status) {
        return true;
      } else {
        toast?.error(response?.message || "Failed to Request feature");
        return false;
      }
    } catch (error) {
      console.error("Request feature error:", error);
      toast?.error("An error occurred while Requesting the feature");
      return false;
    }
  };

  const hasLockedBranches = (feature) => {
    return feature.status_per_branch?.some(
      b => !b.is_unlocked
    );
  };

  const confirmBranchSelection = () => {
    if (!selectedBranchForAction) {
      toast?.warning("Please select a branch");
      return;
    }

    const isUpgrade = selectedPlan > selectedBranchForAction.plan;

    if (isUpgrade) {
      setShowBranchSelector(false);
      setShowUpgradeModal(true);
    } else {
      setShowBranchSelector(false);
      setShowDowngradeModal(true);
    }
  };

  const confirmUpgradeRequest = async () => {

    try {
      const response = await upgrade_plan_request_email({
        branch: selectedBranchForAction,
        plan: selectedPlan,
        type: "Upgrade"
      });

      if (response?.status) {
        toast?.success(
          `Upgrade request sent for ${selectedBranchForAction.name} to ${PLANS.find(p => p.id === selectedPlan)?.name} plan!`
        );
        setShowUpgradeModal(false);
        setSelectedPlan(null);
        setSelectedBranchForAction(null);
      } else {
        toast?.error(response?.message || "Failed to Request Upgrade Plan");
        return false;
      }
    } catch (error) {
      console.error("Request Upgarde Plan error:", error);
      toast?.error("An error occurred while Requesting the Upgrade Plan");
      return false;
    }

  };

  const confirmDowngradeRequest = async () => {

    try {
      const response = await downgrade_plan_request_email({
        branch: selectedBranchForAction,
        plan: selectedPlan,
        type: "Downgrade"
      });

      if (response?.status) {
        toast?.success(
          `Downgrade request sent for ${selectedBranchForAction.name} to ${PLANS.find(p => p.id === selectedPlan)?.name} plan!`
        );
        setShowDowngradeModal(false);
        setSelectedPlan(null);
        setSelectedBranchForAction(null);
      } else {
        toast?.error(response?.message || "Failed to Request Downgrade Plan");
        return false;
      }
    } catch (error) {
      console.error("Request Downgrade Plan error:", error);
      toast?.error("An error occurred while Requesting the Downgrade Plan");
      return false;
    }
  };

  const resetToBaseBranch = () => {
    setSelectedBranch({
      id: userData?._id,
      name: userData?.name,
      type: 'main',
      plan: userData?.plan
    });
    toast?.success(`Switched to main branch: ${userData?.name}`);
  };

  const getCurrentBranchPlan = () => {
    return selectedBranch?.plan || userPlan;
  };

  const FeatureCard = ({ feature }) => {
    const isHovered = hoveredFeature === feature._id;

    return (
      <div
        className={`relative group bg-white rounded-xl border transition-all duration-300 ${isHovered ? 'border-green-300 shadow-lg scale-[1.02]' : 'border-gray-200 shadow-sm hover:shadow-md'
          }`}
        onMouseEnter={() => setHoveredFeature(feature._id)}
        onMouseLeave={() => setHoveredFeature(null)}
      >
        <div className="p-5 border-b border-gray-100">
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <h3 className="font-semibold text-gray-800 text-lg mb-1">{feature.name}</h3>
              <p className="text-sm text-gray-500 line-clamp-2">{feature.description}</p>
            </div>
            {feature.standalone_amount > 0 && (
              <div className="ml-3 flex-shrink-0">
                <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-indigo-50 text-indigo-700">
                  <UserCurrency />  {feature.standalone_amount}
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="p-5">
          <div className="grid grid-cols-3 gap-2">
            {PLANS.map((plan) => {
              const isAllowed = feature.planAccessMap?.[plan.id] || false;
              const PlanIcon = plan.icon;

              return (
                <div
                  key={plan.id}
                  className={`relative rounded-lg p-3 transition-all duration-200 ${isAllowed
                    ? `${plan.lightColor} border ${plan.borderColor}`
                    : 'bg-gray-50 border border-gray-200 opacity-75'
                    }`}
                >
                  <div className="flex flex-col items-center text-center space-y-2">
                    <div className={`p-1.5 rounded-full ${isAllowed ? plan.lightColor : 'bg-gray-100'
                      }`}>
                      <PlanIcon className={`w-4 h-4 ${isAllowed ? plan.textColor : 'text-gray-400'
                        }`} />
                    </div>
                    <span className={`text-xs font-medium ${isAllowed ? plan.textColor : 'text-gray-400'
                      }`}>
                      {plan.name}
                    </span>
                    {isAllowed ? (
                      <CheckCircleOutlined className="w-4 h-4 text-green-500" />
                    ) : (
                      <CloseCircleOutlined className="w-4 h-4 text-gray-300" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="pr-5 pl-5">
          <p className="text-xs font-medium text-gray-600">
            Branch Status:
          </p>

          {feature.status_per_branch?.map(branch => (
            <div
              key={branch.branch_id}
              className="flex items-center justify-between text-xs"
            >
              <span>{branch.branch_name}</span>

              {branch.is_unlocked ? (
                <span className="text-green-600 flex items-center">
                  <UnlockOutlined className="mr-1" />
                  Unlocked
                </span>
              ) : (
                <span className="text-red-500 flex items-center">
                  <LockOutlined className="mr-1" />
                  Locked
                </span>
              )}
            </div>
          ))}
        </div>


        {hasLockedBranches(feature) && (
          <div className="p-5">
            <button
              onClick={() => openFeatureUnlockModal(feature)}
              className="w-full px-2 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition"
            >
              Unlock Feature
            </button>
          </div>
        )}

      </div>
    );
  };

  const PlanCard = ({ plan }) => {
    const PlanIcon = plan.icon;
    const currentPlan = getCurrentBranchPlan();

    let planFeatures = [];

    if (plan.id === 1000) {
      planFeatures = features.filter(f =>
        f.planAccessMap?.[1000]
      );
    }
    else if (plan.id === 2000) {
      planFeatures = features.filter(f =>
        f.planAccessMap?.[2000] && !f.planAccessMap?.[1000]
      );
    }
    else if (plan.id === 3000) {
      planFeatures = features.filter(f =>
        f.planAccessMap?.[3000] &&
        !f.planAccessMap?.[2000] &&
        !f.planAccessMap?.[1000]
      );
    }

    const totalFeatures = features.length;
    const coverage = totalFeatures ? Math.round((planFeatures.length / totalFeatures) * 100) : 0;
    const isCurrentPlan = plan.id === currentPlan;

    return (
      <div className={`relative bg-gradient-to-br ${plan.color} rounded-2xl p-6 text-white overflow-hidden shadow-xl ${isCurrentPlan ? 'ring-4 ring-white ring-opacity-50' : ''}`}>
        <div className="absolute top-0 right-0 w-40 h-40 bg-white opacity-10 rounded-full transform translate-x-20 -translate-y-20" />
        <div className="absolute bottom-0 left-0 w-32 h-32 bg-black opacity-10 rounded-full transform -translate-x-16 translate-y-16" />

        <div className="relative z-10">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 bg-white bg-opacity-20 rounded-xl">
              <PlanIcon className="w-8 h-8" />
            </div>
            <span className="px-3 py-1 bg-white bg-opacity-20 rounded-full text-sm font-medium">
              <UserCurrency />  {plan.Amount}
            </span>
          </div>

          <h3 className="text-2xl font-bold mb-2">{plan.name}</h3>

          {isCurrentPlan && (
            <div className="mb-3 inline-block px-2 py-1 bg-white bg-opacity-30 rounded-lg text-xs font-semibold">
              CURRENT PLAN
            </div>
          )}

          <div className="grid grid-cols-2 gap-4 my-6">
            <div>
              <div className="text-3xl font-bold">{planFeatures.length}</div>
              <div className="text-sm opacity-80">Available Features</div>
            </div>
            <div>
              <div className="text-3xl font-bold">{coverage}%</div>
              <div className="text-sm opacity-80">Coverage</div>
            </div>
          </div>

          {plan.id > currentPlan && (
            <button
              onClick={() => handleUpgradeRequest(plan.id)}
              className="w-full py-3 px-4 bg-white text-gray-900 rounded-xl font-semibold hover:bg-opacity-90 transition-all duration-200 transform hover:scale-[1.02] flex items-center justify-center group"
            >
              <span>Request Upgrade</span>
              <RightOutlined className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
            </button>
          )}

          {plan.id < currentPlan && (
            <button
              onClick={() => handleDowngradeRequest(plan.id)}
              className="w-full py-3 px-4 mt-2 bg-gray-200 text-gray-900 rounded-xl font-semibold hover:bg-gray-300 transition-all duration-200 transform hover:scale-[1.02] flex items-center justify-center group"
            >
              <span>Request Downgrade</span>
              <RightOutlined className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
            </button>
          )}

          <div className="mt-6 space-y-2">
            <p className="text-sm font-medium opacity-80 mb-3">Top features included:</p>
            {planFeatures.slice(0, 3).map(feature => (
              <div key={feature._id} className="flex items-center text-sm">
                <CheckCircleOutlined className="w-4 h-4 mr-2 flex-shrink-0" />
                <span className="truncate">{feature.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const BranchSelectorModal = () => {
    if (!showBranchSelector) return null;

    const allBranches = [
      {
        id: userData?._id,
        name: `${userData?.name} (Main Branch)`,
        type: 'main',
        plan: userData?.plan
      },
      ...subBranches.map(branch => ({
        id: branch._id,
        name: branch.name,
        type: 'sub',
        plan: branch.plan
      }))
    ];

    const action = selectedPlan > (selectedBranchForAction?.plan || 0) ? 'Upgrade' : 'Downgrade';

    return (
      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0 transition-opacity" aria-hidden="true">
            <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

          <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
            <div className="bg-gradient-to-r from-indigo-500 to-indigo-600 px-6 py-8">
              <h3 className="text-2xl font-bold text-white text-center">
                Select Branch for {action}
              </h3>
              <p className="text-white text-center opacity-90 mt-2">
                Choose which branch you want to {action.toLowerCase()} to {PLANS.find(p => p.id === selectedPlan)?.name} plan
              </p>
            </div>

            <div className="px-6 py-8 max-h-96 overflow-y-auto">
              <div className="space-y-3">
                {allBranches.map(branch => (
                  <div
                    key={branch.id}
                    onClick={() => handleBranchSelect(branch)}
                    className={`p-4 border rounded-xl cursor-pointer transition-all ${selectedBranchForAction?.id === branch.id
                      ? 'border-indigo-500 bg-indigo-50 ring-2 ring-indigo-200'
                      : 'border-gray-200 hover:border-indigo-300 hover:bg-gray-50'
                      }`}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        {branch.type === 'main' ? (
                          <ApartmentOutlined className="w-5 h-5 text-indigo-600" />
                        ) : (
                          <ShopOutlined className="w-5 h-5 text-gray-600" />
                        )}
                        <div>
                          <p className="font-medium text-gray-800">{branch.name}</p>
                          <p className="text-xs text-gray-500 mt-1">
                            Current Plan: {PLANS.find(p => p.id === branch.plan)?.name || 'Unknown'}
                          </p>
                        </div>
                      </div>
                      {selectedBranchForAction?.id === branch.id && (
                        <CheckCircleOutlined className="w-5 h-5 text-indigo-600" />
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8 flex space-x-3">
                <button
                  onClick={() => {
                    setShowBranchSelector(false);
                    setSelectedBranchForAction(null);
                  }}
                  className="flex-1 px-4 py-3 border border-gray-300 rounded-xl text-gray-700 font-medium hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmBranchSelection}
                  className="flex-1 px-4 py-3 bg-gradient-to-r from-indigo-500 to-indigo-600 text-white rounded-xl font-medium hover:opacity-90 transition-opacity"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const UpgradeModal = () => {
    if (!showUpgradeModal) return null;

    const selectedPlanData = PLANS.find(p => p.id === selectedPlan);

    return (
      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0 transition-opacity" aria-hidden="true">
            <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

          <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
            <div className={`bg-gradient-to-r ${selectedPlanData?.color} px-6 py-8`}>
              <h3 className="text-2xl font-bold text-white text-center">
                Upgrade {selectedBranchForAction?.name}
              </h3>
              <p className="text-white text-center opacity-90 mt-2">
                Upgrade to {selectedPlanData?.name} Plan
              </p>
            </div>

            <div className="px-6 py-8">
              <div className="bg-indigo-50 p-4 rounded-xl mb-6">
                <p className="text-sm text-indigo-700">
                  <span className="font-semibold">Branch:</span> {selectedBranchForAction?.name}
                </p>
                <p className="text-sm text-indigo-700 mt-1">
                  <span className="font-semibold">Current Plan:</span> {PLANS.find(p => p.id === selectedBranchForAction?.plan)?.name}
                </p>
                <p className="text-sm text-indigo-700 mt-1">
                  <span className="font-semibold">New Plan:</span> {selectedPlanData?.name}
                </p>
              </div>

              <div className="space-y-4">
                <div className="flex items-center p-4 bg-green-50 rounded-xl">
                  <CheckCircleOutlined className="w-6 h-6 text-green-600 mr-3" />
                  <span className="text-gray-700">Access to all {selectedPlanData?.name} features</span>
                </div>
                <div className="flex items-center p-4 bg-blue-50 rounded-xl">
                  <SafetyOutlined className="w-6 h-6 text-blue-600 mr-3" />
                  <span className="text-gray-700">Priority support</span>
                </div>
                <div className="flex items-center p-4 bg-purple-50 rounded-xl">
                  <RiseOutlined className="w-6 h-6 text-purple-600 mr-3" />
                  <span className="text-gray-700">Advanced analytics</span>
                </div>
              </div>

              <div className="mt-8 flex space-x-3">
                <button
                  onClick={() => setShowUpgradeModal(false)}
                  className="flex-1 px-4 py-3 border border-gray-300 rounded-xl text-gray-700 font-medium hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmUpgradeRequest}
                  className={`flex-1 px-4 py-3 bg-gradient-to-r ${selectedPlanData?.color} text-white rounded-xl font-medium hover:opacity-90 transition-opacity`}
                >
                  Confirm Upgrade
                </button>
              </div>

              <p className="text-xs text-gray-500 text-center mt-4">
                Our team will contact you shortly to complete the upgrade process
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const DowngradeModal = () => {
    if (!showDowngradeModal) return null;

    const selectedPlanData = PLANS.find(p => p.id === selectedPlan);

    return (
      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0 transition-opacity" aria-hidden="true">
            <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

          <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">

            <div className={`bg-gradient-to-r ${selectedPlanData?.color} px-6 py-8`}>
              <h3 className="text-2xl font-bold text-white text-center">
                Downgrade {selectedBranchForAction?.name}
              </h3>
              <p className="text-white text-center opacity-90 mt-2">
                to {selectedPlanData?.name} Plan
              </p>
            </div>

            <div className="px-6 py-8">
              <div className="bg-yellow-50 p-4 rounded-xl mb-6">
                <p className="text-sm text-yellow-700">
                  <span className="font-semibold">Branch:</span> {selectedBranchForAction?.name}
                </p>
                <p className="text-sm text-yellow-700 mt-1">
                  <span className="font-semibold">Current Plan:</span> {PLANS.find(p => p.id === selectedBranchForAction?.plan)?.name}
                </p>
                <p className="text-sm text-yellow-700 mt-1">
                  <span className="font-semibold">New Plan:</span> {selectedPlanData?.name}
                </p>
              </div>

              <div className="space-y-4">
                <div className="flex items-center p-4 bg-yellow-50 rounded-xl">
                  <CheckCircleOutlined className="w-6 h-6 text-yellow-600 mr-3" />
                  <span className="text-gray-700">
                    Access limited to {selectedPlanData?.name} plan features only
                  </span>
                </div>

                <div className="flex items-center p-4 bg-red-50 rounded-xl">
                  <SafetyOutlined className="w-6 h-6 text-red-600 mr-3" />
                  <span className="text-gray-700">
                    Premium and advanced features will be disabled
                  </span>
                </div>

                <div className="flex items-center p-4 bg-orange-50 rounded-xl">
                  <RiseOutlined className="w-6 h-6 text-orange-600 mr-3" />
                  <span className="text-gray-700">
                    Reports and analytics access may be reduced
                  </span>
                </div>
              </div>

              <div className="mt-8 flex space-x-3">
                <button
                  onClick={() => setShowDowngradeModal(false)}
                  className="flex-1 px-4 py-3 border border-gray-300 rounded-xl text-gray-700 font-medium hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>

                <button
                  onClick={confirmDowngradeRequest}
                  className={`flex-1 px-4 py-3 bg-gradient-to-r ${selectedPlanData?.color} text-white rounded-xl font-medium hover:opacity-90 transition-opacity`}
                >
                  Confirm Downgrade
                </button>
              </div>

              <p className="text-xs text-gray-500 text-center mt-4">
                Our team will contact you shortly to complete the downgrade process
              </p>

            </div>
          </div>
        </div>
      </div>
    );
  };

  const FeatureUnlockModal = () => {
    const [localSelectedBranch, setLocalSelectedBranch] = useState(null);

    const lockedBranches = React.useMemo(() => {
      if (!showFeatureUnlockModal || !selectedFeatureForUnlock?.status_per_branch) {
        return [];
      }

      return selectedFeatureForUnlock?.status_per_branch
        ?.filter(branch => !branch.is_unlocked)
        ?.map(lockedBranch => {
          if (lockedBranch.branch_id === userData?._id) {
            return {
              id: userData?._id,
              name: userData?.name,
              plan: userData?.plan,
              isMain: true
            };
          } else {
            const subBranch = subBranches.find(b => b._id === lockedBranch.branch_id);
            return subBranch ? {
              id: subBranch._id,
              name: subBranch.name,
              plan: subBranch.plan,
              isMain: false
            } : null;
          }
        })
        ?.filter(branch => branch !== null) || [];
    }, [showFeatureUnlockModal, selectedFeatureForUnlock, userData, subBranches]);

    const isInitiallySelectedBranchLocked = React.useMemo(() => {
      return selectedBranchForFeatureUnlock &&
        lockedBranches.some(b => b.id === selectedBranchForFeatureUnlock.id);
    }, [selectedBranchForFeatureUnlock, lockedBranches]);

    useEffect(() => {
      if (!showFeatureUnlockModal) return;

      if (isInitiallySelectedBranchLocked) {
        setLocalSelectedBranch(selectedBranchForFeatureUnlock);
      } else if (lockedBranches.length > 0) {
        setLocalSelectedBranch(lockedBranches[0]);
      } else {
        setLocalSelectedBranch(null);
      }
    }, [showFeatureUnlockModal, selectedFeatureForUnlock, selectedBranchForFeatureUnlock, isInitiallySelectedBranchLocked, lockedBranches]);

    const handleBranchSelect = (branch) => {
      setLocalSelectedBranch(branch);
    };

    const handleConfirmUnlock = async () => {
      try {
        setSelectedBranchForFeatureUnlock(localSelectedBranch);
        const success = await confirmFeatureUnlock(localSelectedBranch);

        if (success) {
          setShowFeatureUnlockModal(false);
          toast?.success(
            "Request submitted successfully! Our admin will review it shortly and get back to you."
          );
        }
      } catch (error) {
        console.error("Error in handleConfirmUnlock:", error);
      }
    };

    const selectedPlanData = PLANS.find(p => p.id === localSelectedBranch?.plan);

    if (!showFeatureUnlockModal) return null;

    if (lockedBranches.length === 0) {
      return (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity">
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>

            <span className="hidden sm:inline-block sm:align-middle sm:h-screen">
              &#8203;
            </span>

            <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-gradient-to-r from-purple-500 to-indigo-600 px-6 py-8">
                <h3 className="text-2xl font-bold text-white text-center">
                  Feature Already Unlocked
                </h3>
              </div>

              <div className="px-6 py-8">
                <div className="bg-green-50 p-4 rounded-xl mb-6">
                  <p className="text-sm text-green-700 text-center">
                    <UnlockOutlined className="w-5 h-5 mr-2 inline-block" />
                    This feature is already unlocked for all branches.
                  </p>
                </div>

                <div className="mt-8 flex space-x-3">
                  <button
                    onClick={() => setShowFeatureUnlockModal(false)}
                    className="flex-1 px-4 py-3 bg-gradient-to-r from-purple-500 to-indigo-600 text-white rounded-xl font-medium hover:opacity-90 transition-opacity"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0 transition-opacity">
            <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <span className="hidden sm:inline-block sm:align-middle sm:h-screen">
            &#8203;
          </span>

          <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
            <div className="bg-gradient-to-r from-purple-500 to-indigo-600 px-6 py-8">
              <h3 className="text-2xl font-bold text-white text-center">
                Unlock Feature
              </h3>
              <p className="text-white text-center opacity-90 mt-2">
                {selectedFeatureForUnlock?.name}
              </p>
            </div>

            <div className="px-6 py-8">
              <div className="mb-6">
                <p className="text-sm font-semibold text-gray-700 mb-3">
                  Select Branch to Unlock
                </p>

                <p className="text-xs text-gray-500 mb-3">
                  Showing {lockedBranches.length} branch(es) where this feature is locked
                </p>

                <div className="space-y-3 max-h-48 overflow-y-auto">
                  {lockedBranches.map(branch => {
                    const isSelected = localSelectedBranch?.id === branch.id;

                    return (
                      <div
                        key={branch.id}
                        onClick={() => handleBranchSelect(branch)}
                        className={`flex items-center justify-between p-4 rounded-xl cursor-pointer border transition-all
                        ${isSelected
                            ? "border-purple-500 bg-purple-50"
                            : "border-gray-200 hover:bg-gray-50"
                          }`}
                      >
                        <div>
                          <p className="font-medium text-gray-800">
                            {branch.name} {branch.isMain ? "(Main Branch)" : ""}
                          </p>
                          <p className="text-xs text-gray-500">
                            Plan: {PLANS.find(p => p.id === branch.plan)?.name}
                          </p>
                        </div>

                        <LockOutlined className="text-red-500 text-lg" />
                      </div>
                    );
                  })}
                </div>
              </div>

              {localSelectedBranch && (
                <div className="bg-yellow-50 p-4 rounded-xl mb-6">
                  <p className="text-sm text-yellow-700">
                    <span className="font-semibold">Branch:</span>{" "}
                    {localSelectedBranch.name} {localSelectedBranch.isMain ? "(Main Branch)" : ""}
                  </p>
                  <p className="text-sm text-yellow-700 mt-1">
                    <span className="font-semibold">Current Plan:</span>{" "}
                    {selectedPlanData?.name}
                  </p>
                  <p className="text-sm text-yellow-700 mt-1">
                    <span className="font-semibold">Feature to Unlock:</span>{" "}
                    {selectedFeatureForUnlock?.name}
                  </p>
                </div>
              )}

              <div className="mt-8 flex space-x-3">
                <button
                  onClick={() => setShowFeatureUnlockModal(false)}
                  className="flex-1 px-4 py-3 border border-gray-300 rounded-xl text-gray-700 font-medium hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>

                <button
                  disabled={!localSelectedBranch}
                  onClick={handleConfirmUnlock}
                  className="flex-1 px-4 py-3 bg-gradient-to-r from-purple-500 to-indigo-600 text-white rounded-xl font-medium hover:opacity-90 transition-opacity disabled:opacity-50"
                >
                  Send Unlock Request for {localSelectedBranch?.name}
                </button>
              </div>

              <p className="text-xs text-gray-500 text-center mt-4">
                Our team will contact you shortly to complete the unlock process
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const BranchSelector = () => {
    const allBranches = [
      {
        id: userData?._id,
        name: `${userData?.name} (Main Branch)`,
        type: 'main',
        plan: userData?.plan
      },
      ...subBranches.map(branch => ({
        id: branch._id,
        name: branch.name,
        type: 'sub',
        plan: branch.plan
      }))
    ];

    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2">
            <ApartmentOutlined className="w-5 h-5 text-green-600" />
            <h3 className="font-semibold text-gray-800">Current Branch View</h3>
          </div>
          <button
            onClick={resetToBaseBranch}
            className="flex items-center space-x-2 px-3 py-1.5 bg-green-50 text-green-700 rounded-lg text-sm hover:bg-green-100 transition-colors"
          >
            <SwapOutlined className="w-4 h-4" />
            <span>Reset to Main Branch</span>
          </button>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {allBranches.map(branch => (
            <button
              key={branch.id}
              onClick={() => setSelectedBranch(branch)}
              className={`p-3 rounded-xl border transition-all ${selectedBranch?.id === branch.id
                ? 'border-green-500 bg-green-50 ring-2 ring-green-200'
                : 'border-gray-200 hover:border-green-300 hover:bg-gray-50'
                }`}
            >
              <div className="flex items-center space-x-2">
                {branch.type === 'main' ? (
                  <ApartmentOutlined className={`w-4 h-4 ${selectedBranch?.id === branch.id ? 'text-green-600' : 'text-gray-400'}`} />
                ) : (
                  <ShopOutlined className={`w-4 h-4 ${selectedBranch?.id === branch.id ? 'text-green-600' : 'text-gray-400'}`} />
                )}
                <div className="text-left">
                  <p className="text-sm font-medium text-gray-800 truncate max-w-[200px]">
                    {branch.name}
                  </p>
                  <p className="text-xs text-gray-500">
                    {PLANS.find(p => p.id === branch.plan)?.name || 'Unknown'}
                  </p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    );
  };

  const StatsBar = () => {
    const totalFeatures = features.length;
    const basicFeatures = features.filter(f => f.planAccessMap?.[1000]).length;
    const standardFeatures = features.filter(f => f.planAccessMap?.[2000]).length;
    const premiumFeatures = features.filter(f => f.planAccessMap?.[3000]).length;

    return (
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
        <div className="bg-gradient-to-br from-indigo-500 to-indigo-600 rounded-xl p-4 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm opacity-90">Total Features</p>
              <p className="text-2xl font-bold">{totalFeatures}</p>
            </div>
            <TrophyOutlined className="w-8 h-8 opacity-80" />
          </div>
        </div>
        <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl p-4 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm opacity-90">Basic Plan</p>
              <p className="text-2xl font-bold">{basicFeatures}</p>
            </div>
            <StarOutlined className="w-8 h-8 opacity-80" />
          </div>
        </div>
        <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-4 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm opacity-90">Standard Plan</p>
              <p className="text-2xl font-bold">{standardFeatures}</p>
            </div>
            <ThunderboltOutlined className="w-8 h-8 opacity-80" />
          </div>
        </div>
        <div className="bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl p-4 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm opacity-90">Premium Plan</p>
              <p className="text-2xl font-bold">{premiumFeatures}</p>
            </div>
            <CrownOutlined className="w-8 h-8 opacity-80" />
          </div>
        </div>
      </div>
    );
  };
  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <ScrollWrapper summary={2}>
          <div className="p-6 space-y-8">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xl font-bold text-gray-800">Plan Upgradation</p>
                <p className="text-gray-500 mt-1">
                  Compare plans and request upgrades for additional features
                </p>
              </div>
              <div className="flex items-center space-x-2 bg-indigo-50 px-4 py-2 rounded-lg">
                <HighlightOutlined className="w-5 h-5 text-indigo-600" />
                <span className="text-indigo-700 font-medium">
                  {features.length} Features Available
                </span>
              </div>
            </div>

            <BranchSelector />

            <StatsBar />

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {PLANS.map(plan => (
                <PlanCard key={plan.id} plan={plan} />
              ))}
            </div>

            <div className="mt-12">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-semibold text-gray-800">
                  Feature-wise Plan Comparison
                </h2>
                <div className="flex items-center space-x-2 text-sm text-gray-500">
                  <div className="flex items-center">
                    <CheckCircleOutlined className="w-4 h-4 text-green-500 mr-1" />
                    <span>Available</span>
                  </div>
                  <div className="flex items-center ml-3">
                    <CloseCircleOutlined className="w-4 h-4 text-gray-300 mr-1" />
                    <span>Not Available</span>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {features.map(feature => (
                  <FeatureCard key={feature._id} feature={feature} />
                ))}
              </div>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 border border-gray-200 mt-8">
              <div className="flex items-start space-x-4">
                <div className="p-3 bg-indigo-100 rounded-lg">
                  <RocketOutlined className="w-6 h-6 text-indigo-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800 mb-1">How it works</h3>
                  <p className="text-sm text-gray-600">
                    Each feature shows its availability across different plans.
                    You can select different branches to view their current plans.
                    Click on "Request Upgrade/Downgrade" for any plan, then select the branch
                    you want to modify. Our team will contact you to discuss the details.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <BranchSelectorModal />
          <UpgradeModal />
          <DowngradeModal />
          <FeatureUnlockModal />

        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default UpgradationDisplay;